module.exports = __webpack_public_path__ + "static/media/ic_categories_cosmetics.8dc22983.svg";